/** @format */

export class Certona {
	scheme: string;
	displayName: string;
	productDisplayLimit: number;
	showViewMoreLink: boolean;

	constructor(
		scheme: string,
		displayName: string,
		productDisplayLimit: number,
		showViewMoreLink: boolean
	) {
		this.scheme = scheme;
		this.displayName = displayName;
		this.productDisplayLimit = productDisplayLimit;
		this.showViewMoreLink = showViewMoreLink;
	}
}

export class CertonaDefault {
	dsg: Certona[] = [];
	gg: Certona[] = [];

	/* istanbul ignore next */
	constructor() {
		// home_rr Certona scheme
		this.dsg.push(new Certona('home_rr', 'We Found These For You', 5, false));

		// home2_rr Certona scheme
		this.dsg.push(new Certona('home3_rr', 'Hot In Your Area', 5, false));

		this.gg.push(new Certona('homeratings_rr', 'We Found These For You', 5, false));

		this.gg.push(new Certona('home1_rr', 'Recommended For You', 5, false));
	}

	public getCertona(chain: string) {
		return this[chain];
	}
}
